import { transformSearch } from "@/api/helper.ts";
import { queryClient } from "@/query-client.ts";
import { queryOptions, useMutation } from "@tanstack/react-query";
import { z } from "zod";
import lookUptItemService from "../services/look-up-item-service";

export const categorySearchSchema = z.object({
	search: z.string().optional(),
	include: z.string().optional(),
	branchId: z.string().nullable().optional(),
	page: z.number().nullable().optional(),
	per_page: z.number().optional(),
});

export const categoryQueryOptions = (search?: z.infer<typeof categorySearchSchema>, options?: { enabled: boolean }) => {
	return queryOptions({
		queryKey: ["category", search],
		queryFn: () => lookUptItemService.list(transformSearch(search, ["search"])),
		...options,
	});
};

// export const regionQueryOptions = (regionId: string) => {
// 	return queryOptions({
// 		queryKey: ["region", regionId],
// 		queryFn: () => regionService.findById(regionId),
// 	});
// };

export const useLookUpItemCreateMutation = (branchId?: string) => {
	return useMutation({
		mutationKey: ["category", branchId],
		mutationFn: lookUptItemService.create,
		meta: {
			successMessage: "Category created successfully",
		},
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ["category"] }),
	});
};

// export const useRegionMutation = (regionId?: string) => {
// 	return useMutation({
// 		mutationKey: ["region", regionId],
// 		mutationFn: regionService.upsert,
// 		meta: {
// 			successMessage: "Region updated successfully",
// 		},
// 		onSuccess: () => queryClient.invalidateQueries({ queryKey: ["region"] }),
// 	});
// };
